import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-healthpicks-unblock',
  templateUrl: './healthpicks-unblock.component.html',
  styleUrls: ['../style/global.css', '../style/hp-shared.css', './healthpicks-unblock.component.css'],
})
export class HealthpicksUnblockComponent implements OnInit {
  countdown = 10;
  initialize = false;
  @Input()
  clientId: string;
  constructor() {}

  ngOnInit(): void {
    setTimeout(() => {
      this.initialize = true;
      const interval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.redirect();
          clearInterval(interval);
        }
      }, 1000);
    }, 1000);
  }

  redirect() {
    location.href = environment.apps[this.clientId].appUrl;
  }

  get appname() {
    return 'HealthPicks Portal';
  }
}
